<template>
  <div>
    <PublicLayout>
      <HeaderNav />
      <header class="sub-product-header">
        <div class="container">
          <h1>{{ showProductTitle }}</h1>
        </div>
      </header>

      <!-- 1 核酸飲料 天然DN膠原蛋白 -->
      <article
        id="product1Detail"
        v-if="$route.params.pid == 1"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/drink_2025-thumb-510x510-1577.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  邁向未來25年，兼顧自然環境，採用備受矚目的新成分──蛋白聚醣
                </h2>
                <p>
                  此為採用獨特技術，含有稱為生命基本物質的水溶性核酸（DNA/RNA）和核蛋白的保健飲料。
                  <br/>
                  富地滋致力於永續發展，為了珍惜有限的自然資源，我們將原有的含有軟骨素的鯊魚軟骨萃取物與含有玻尿酸的雞冠萃取物，替換為同時擁有軟骨素硫酸與玻尿酸特性的──蛋白聚醣含有鮭魚鼻軟骨萃取物。
                  <br/>
                  以由次世代核酸研究所「FD」研發的核酸原料「coreF-Revo.1」為基礎，搭配膠原胜肽、精胺酸、蛋白聚醣、維生素、礦物質等多種營養素精製而成。
                  <br/>
                  口感清爽、甜度低，作為每日營養補充飲品，有助於維持日常健康狀態。
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">產品名稱</th>
                    <td class="font-weight-bold">富地滋DN膠原(清涼飲料水)</td>
                  </tr>
                  <tr>
                    <th>會員價格(統一售價)</th>
                    <td>NT. 3,600元/瓶</td>
                  </tr>
                  <tr>
                    <th>內容量</th>
                    <td>720ml</td>
                  </tr>
                  <tr>
                    <th>保存方法</th>
                    <td>
                      請存放於陰涼乾燥通風處，避免陽光直射。開瓶後請置於冰箱冷藏保存，並盡早飲用完畢。
                    </td>
                  </tr>
                  <tr>
                    <th>成分內容物</th>
                    <td>
                      膠原胜肽(豬)、甜味劑(赤藻糖醇)、砂糖、鮭魚精巢提取物、酵母提取物〔酵母菌 (Candida utilis)〕、食用酵母(鋅酵母)、鮭魚鼻軟骨提取物、檸檬酸、
                      抗壞血酸(維生素C)、L-精胺酸、碳酸鎂、防腐劑(苯甲酸鈉)、菸鹼醯胺、香料、焦糖色素、本多酸鈣、甜味劑(蔗糖素)、複合乳化劑(脂肪酸山梨醇酐酯、大豆卵磷脂、乳糖)、
                      鹽酸吡哆辛(維生素B6)、核黃素(維生素B2)、硝酸硫胺明(維生素B1)、葉酸、氰鈷胺明(維生素B12)
                    </td>
                  </tr>
                  <tr>
                    <th>營養標示(每100ml)</th>
                    <td>
                      熱量：96.8大卡、蛋白質：14.0公克、脂肪：0公克、碳水化合物：10.2公克、糖：3.7公克、鈉：40.0毫克
                    </td>
                  </tr>
                  <tr>
                    <th>飲用方式</th>
                    <td>
                      飲用前請先輕搖均勻，每日適量飲用，早晚皆適宜。可依個人喜好口感搭配加水稀釋飲用。
                    </td>
                  </tr>
                  <tr>
                    <th>過敏原標示</th>
                    <td>本產品含有牛奶及其製品、魚類及其製品、大豆</td>
                  </tr>
                </table>
                <div>
                  <p style="font-size: 14px">
                    ※本產品不是藥物，不是用於疾病的治療，但對於日常保養有積極的意義。均衡飲食是維持健康的要素。
                  </p>
                  <p style="font-size: 14px">
                    ※請遵守食品安全管理辦法，切勿誇大不實或宣稱療效，以免觸法！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <section class="m-sec">
          <div class="container">
            <h2 class="section-title">飲用方法</h2>
            <p>
              建議一天飲用量為30~60ml，直接冷藏後飲用或是添加冰水或喜歡的冷飲飲用皆可。
              如果有出現浮游物或沉澱的情形，並不是變質，請先輕搖後再飲用。
              開瓶後請冷藏，並盡早飲用。
            </p>
          </div>
        </section> -->
      </article>
      <!-- 1 核酸飲料 天然DN膠原蛋白 end -->
      <!-- 2 富地滋樂活隨身包 -->
      <article
        id="product2Detail"
        v-if="$route.params.pid == 2"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/BCAA_newpkg-thumb-510x510-1421_04.png"
                  class="product-detail-main-img w-100"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">關鍵胺基酸 ‧ 維持健康好肌力</h2>
                <p>升級再進化！添加的胺基酸種類由原來的4種增加到12種。</p>
                <p>
                  為了更有效地合成肌肉蛋白，添加了研究開發的「全9種必需胺基酸綜合成分」，以及與麩醯胺酸具有相同作用的「DL-胺基丙酸」。完整均衡添加製造肌肉的原料-胺基酸，提升運動效率，打造強勁體魄。
                </p>
                <p>
                  攜帶方便的長條形包裝設計，外出時也能輕鬆食用。
                  清甜爽口的風味更添一番美味。
                </p>
              </div>
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">產品名稱</th>
                    <td class="font-weight-bold">富地滋樂活隨身包</td>
                  </tr>
                  <tr>
                    <th>會員價格(統一售價)</th>
                    <td>NT. 2,250元/盒</td>
                  </tr>
                  <tr>
                    <th>內容量</th>
                    <td>105公克(3.5g×30包)</td>
                  </tr>
                  <tr>
                    <th>保存方法</th>
                    <td>請放置於陰涼乾燥通風處，避免陽光直射。</td>
                  </tr>
                  <tr>
                    <th>成分內容物</th>
                    <td>
                      甜味劑(麥芽糖醇)、彈性蛋白(魚)、L-白胺酸、DL-胺基丙酸、L-α胺基異戊酸、L-異白胺酸、檸檬酸、麩醯胺酸、胺基乙酸、L-二胺基己酸、香料、磷酸鈣、甜味劑(阿斯巴甜、索馬甜、甜菊醣苷、醋磺內酯鉀)、L-羥丁胺酸、大豆卵磷脂、L-苯丙胺酸、普魯蘭膠、L-蛋胺酸、L-組胺酸、菸鹼醯胺、L-色胺酸、鹽酸吡哆辛(維生素B6)
                    </td>
                  </tr>
                  <tr>
                    <th>營養標示(每份3.5公克)</th>
                    <td>
                      熱量：13.9大卡、蛋白質：2.1公克、脂肪：0公克、碳水化合物：1.3公克、糖：0公克、鈉：0.3毫克
                    </td>
                  </tr>
                  <tr>
                    <th>飲用方式</th>
                    <td>
                      建議一天1~2包。可依照個人口感，搭配飲用水，亦可溶於水中飲用或搭配富地滋DN膠原飲品。
                      <br />
                      開封後請盡快飲用完畢。(※建議運動前、運動後食用)
                    </td>
                  </tr>
                  <tr>
                    <th>注意事項</th>
                    <td>本產品含甜味劑（阿斯巴甜），苯酮尿症者不宜食用。</td>
                  </tr>
                  <tr>
                    <th>過敏原標示</th>
                    <td>本產品含有魚類及其製品、大豆</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <!-- <section class="m-sec">
          <div class="container">
            <h2 class="section-title">食用方法</h2>
            <p>
              建議一天1~2包，搭配飲用水一起食用。另外也可以溶於水之後再飲用。
              開封後請盡快飲用完畢。
            </p>
          </div>
        </section> -->
      </article>
      <!-- 2 富地滋樂活隨身包 end -->
      <!-- 3 新‧夢莎ED膠原蛋白飲 -->
      <article
        id="product3Detail"
        v-if="$route.params.pid == 3"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/IMG_058-thumb-510x363-1106.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  鳳梨由來的賽洛美及搭配膠原蛋白的美容飲
                </h2>
                <p>
                  加入鳳梨由來的賽洛美、採用富地滋獨家膠原蛋白以及搭配原本「多肽型膠原蛋白」的三倍。維他命C也增量了10%，是一瓶多方面實現美的培育力、且均衡配合維他命及礦物質的飲品。幫助我們每日健康又美麗。
                  這款膠原蛋白飲推薦給對於想提高每天水潤潤實感的人們、追求透明感、清澈的美的人們以及想要
                  每天Q彈緊緻、朝氣蓬勃生活的人們。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">飲用方法</h2>
            <p>建議飲用量1天1瓶，冷藏並輕搖後再飲用。 開封後請盡速飲用完畢。</p>
          </div>
        </section>
      </article>
      <!-- 3 新‧夢莎ED膠原蛋白飲 end -->
      <!-- 4 LU tia 高機能美容精華液 -->
      <article
        id="product4Detail"
        v-if="$route.params.pid == 4"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/LU_gia高機能美容精華液.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  產品名稱「gia」的由來<br />
                  Energia(能量／energia)：表達產品是以著眼於肌膚能量層面為核心的概念
                </h2>
                <p>
                  為肌膚注入能量！邁向更高進化的創新美容液，以對細節的極致追求實現抗老保養，引導肌膚邁向前所未有的體驗。將化妝水、美容液、乳液、精華霜等功能合而為一，洗臉後只需一步即可完成全方位的護膚。
                </p>
                <p>
                  在賦予肌膚緊緻與彈性的同時，充分滋潤肌膚，減少因乾燥引起的細紋明顯程度。
                </p>
              </div>
            </div>

           <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">獨家研發──FORDAYS 首款保養品用的核酸素材</div>
                <p>
                  在以往保養品中所添加的4種核酸成分之中，獨自開發出其中2種核酸成分：Hada.Core-S25(水解魚精萃取物)與 Hada.Core-D25(水解DNA-Na)。
                </p>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    4種核酸成分
                  </h3>
                  <p>在新一代的LU gia 中，配合了這兩種原創的核酸成分（水解魚精萃取物、水解DNA-Na），再加上講究機能性的三磷酸腺苷（Adenosine Triphosphate）與 DNA-Na，共計4種核酸成分，使產品達到更進一步的進化。</p>
                </div>
              </div>
            </div>

            <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">專注於提升肌膚能量層級的極致抗老護理</div>
                <p>
                  全新添加了專為肌膚能量開發的原創核酸成分 Hada.Core-S25(水解魚白子萃取物）與 Hada.Core-D25(水解DNA鈉)。
                </p>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    輔酶 Q10／野生橄欖新芽幹細胞萃取 / 褐藻萃取物 / 鹵蟲萃取物 / 極地雪藻萃取物 / Porgeline<sup>TM</sup>抗衰素
                  </h3>
                  <p>維持配方中抗氧化成分輔酶 Q10,以及來自野生橄欖新芽幹細胞萃取的成分，還有在嚴苛環境下生長的海藻生命力成分「褐藻萃取物(Regenesa)」，並且添加保護肌膚免受各種環境影響的「鹵蟲萃取物」、極地雪藻萃取物(snow algae)」，以及 Porgeline<sup>TM</sup>抗衰素」。</p>
                </div>
                <p>追求極致完美的抗老化配方，賦予肌膚緊緻與彈性的同時，減少因乾燥引起的小細紋。</p>
              </div>
            </div>
            <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">讓肌膚持久滋潤飽滿及清爽水嫩</div>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    肌膚持續滋潤飽滿、緊緻有彈性
                  </h3>
                  <p>高濃度配合的 4 種核酸成分以及核酸輔助成分「葉酸」、「翅果鐵刀木萃取物」「ACETYL HEXAPEPTIDE-51 AMIDE」，使肌膚持續滋潤飽滿、緊緻有彈性。</p>
                </div>
                <div>
                  <h3 class="subtitle-pink">
                    有效長時間維持肌膚水潤
                  </h3>
                  <p>
                    參考天然保濕因子（NMF）的胺基酸比例所調配的「胺基酸複合物」、Fordays 獨家成分「Kasparin (hexapeptide-42胜肽/多肽類」，以及延時保濕成分「生物糖膠」，有效長時間維持肌膚水潤。
                  </p>
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-5">
              <div class="col-md-12">
                <div class="cta-pink">如融化般貼合肌膚、深層保濕的特殊乳化技術</div>
                <div class="mt-5">
                  <h3 class="subtitle-pink">
                    微乳化技術
                  </h3>
                  <p>柔軟的乳霜狀美容液在肌膚上如融化般迅速吸收，滲透至肌膚角質層的每個角落。並且採用特殊乳化技術「微乳化技術」，使肌膚質地細緻，像滲透感般被吸附進肌膚角質層內。洗臉後只要一個步驟，即可同時享受化妝水的水潤感、乳液的柔滑感及乳霜的保濕感。賦予肌膚細緻光滑，並調理肌理，打造透明感。</p>
                </div>
              </div>
            </div>
            
            <div class="row justify-content-center">
              <div class="col-md-12">
                <table class="light-table mt-4 mb-4">
                  <tr>
                    <th width="35%">產品名稱</th>
                    <td class="font-weight-bold">LU gia 高機能美容精華液</td>
                  </tr>
                  <tr>
                    <th>會員價格(統一售價)</th>
                    <td>NT. 4,000元/瓶</td>
                  </tr>
                  <tr>
                    <th>內容量</th>
                    <td>50公克</td>
                  </tr>
                  <tr>
                    <th>使用方式</th>
                    <td class="font-weight-bold">
                      洗臉後，取適量於掌心，均勻塗抹於全臉。集結化妝水、美容液、乳液、乳霜功效於一瓶。
                      <br />
                      肌膚保養只要一個步驟便大功告成。
                    </td>
                  </tr>
                  <tr>
                    <th>進階使用方法</th>
                    <td class="font-weight-bold">
                      請依據保養目的，配合夢莎逆時雙效保養品系列Ⅱ。
                    </td>
                  </tr>
                  <tr>
                    <th>溫柔呵護</th>
                    <td>
                      <ul type="circle">
                        <li>不使用酒精、礦物油、色素、香料。</li>
                        <li>
                          已進行過貼膚測試・過敏測試。(所有測試者皆通過測試。但並非表示所有人都不會有肌膚敏感或刺激的情形發生。)
                        </li>
                      </ul>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
      </article>
      <!-- 4 LU tia 高機能美容精華液 end -->
      <!-- 5 夢莎逆時雙效潔面乳Ⅱ -->
      <article
        id="product5Detail"
        v-if="$route.params.pid == 5"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效潔面乳Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  擁有微溫感的卸妝感受<br />潔面卸妝+溫感按摩
                </h2>
                <p>
                  在肌膚上延展後會產生微溫感。卸妝的同時也能擁有按摩的效果，能快速溶解妝容，徹底洗淨。含有保濕成分賦予肌膚水潤感。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>110g</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-12">
                <div>
                  <h3 class="subtitle-black">徹底去除髒污</h3>
                  <ul>
                    <li>快速溶解妝容不殘留，讓人感受到洗後的潔淨感。</li>
                    <li>
                      具有洗淨輔助成分的無患子種子萃取物，守護肌膚的同時，也洗去細微的殘妝，發揮徹底洗淨的功效。
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">讓人感到愉快的溫度</h3>
                  <ul>
                    <li>
                      接觸到肌膚後感受到微溫感。卸妝的同時也享受到溫感按摩的效果，帶給使用者更舒適的觸感。
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">洗後肌膚保持潤澤</h3>
                  <ul>
                    <li>4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。</li>
                    <li>
                      添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na
                      等保濕成分。洗後依然維持肌膚潤澤效果。
                    </li>
                    <li>
                      保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。
                    </li>
                    <li>甘草酸 2K成分，保護肌膚，也有助於肌膚的健康。</li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">讓人心情愉悅的香氣</h3>
                  <ul>
                    <li>
                      來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="subtitle-black">對肌膚更溫柔的用心</h3>
                  <ul>
                    <li>不使用酒精、礦物油、色素和香料。</li>
                  </ul>
                </div>
                <div class="product-using-hint">
                  <h3 class="mt-0">使用方法</h3>
                  <p>
                    請在肌膚處於乾燥時使用。取用適量於掌心，在掌心推展開後，仔細地輕輕塗抹於肌膚上。彩妝溶解後，使用大量溫水充分洗淨。
                  </p>
                  <p class="text-small">※接觸到肌膚後會感受到微溫。</p>
                  <p class="text-small">
                    ※卸除眼妝時，建議使用專用的卸妝產品。
                  </p>
                  <p class="text-small mb-0">
                    ※接觸到眼睛可能會引起疼痛不適，請務必留意。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
      <!-- 5 夢莎逆時雙效潔面乳Ⅱ end -->
      <!-- 6 夢莎逆時雙效洗顏霜Ⅱ -->
      <article
        id="product6Detail"
        v-if="$route.params.pid == 6"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效洗顏霜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  綿密細緻的泡泡確實潔淨肌膚的每個角落 <br />
                  洗顏+潔顏卸妝
                </h2>
                <p>
                  奶油般綿密細緻的泡泡能確實潔淨肌膚。含有卸妝成分，能卸除防曬乳或BB霜。含有保濕成分賦予肌膚水潤感。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>100g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">徹底潔淨髒污</p>
            <ul>
              <li>奶油般豐盈細緻的泡泡，能緊密貼合肌膚，徹底洗淨每個角落。</li>
              <li>
                含有洗淨輔助成分無患子種子萃取物，守護肌膚的同時也能洗淨髒污。
              </li>
              <li>能輕鬆洗淨泡泡，帶來清爽不殘留的感受。</li>
            </ul>
            <p class="font-weight-bold">卸除防曬乳或淡妝</p>
            <ul>
              <li>配合卸妝成分，能卸除防曬乳或BB霜等淡妝。</li>
            </ul>
            <p class="font-weight-bold">洗後肌膚保持潤澤</p>
            <ul>
              <li>4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。</li>
              <li>
                添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na
                等保濕成分。洗後依然維持肌膚潤澤效果。
              </li>
              <li>
                保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。
              </li>
              <li>甘草酸硬脂酯的成分守護肌膚，有助於肌膚的健康。</li>
            </ul>
            <p class="font-weight-bold">讓人心情愉悅的香氣</p>
            <ul>
              <li>
                來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。
              </li>
            </ul>
            <p class="font-weight-bold">對肌膚更溫柔的用心</p>
            <ul>
              <li>不使用酒精、礦物油、色素和香料。</li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">使用方法</h3>
              <p class="mb-0">
                取適量在掌心，搓揉起泡後洗臉，再用溫水洗去泡泡。 <br />
                如果使用起泡網，更能輕易做出更細緻豐盈的泡沫。
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 6 夢莎逆時雙效洗顏霜Ⅱ end -->
      <!-- 7 夢莎逆時雙效洗顏皂Ⅱ -->
      <article
        id="product7Detail"
        v-if="$route.params.pid == 7"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效洗顏皂Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  綿密豐盈的泡泡徹底洗淨肌膚 <br />
                  洗顏+泡泡面膜
                </h2>
                <p>
                  秉持容易起泡，又擁有綿密細緻的泡泡質量，透過柔軟豐盈的泡泡徹底洗淨肌膚。含有保濕成分賦予肌膚水潤感。也可用來當泡泡面膜將毛孔內深層髒污吸附出來。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>標準重量100g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">徹底洗淨髒污</p>
            <ul>
              <li>
                秉持泡泡多且綿密細緻持久的質量，透過柔軟豐盈的泡泡，徹底洗淨肌膚每個角落。
              </li>
              <li>
                也可作為泡泡面膜使用。柔軟又有彈性的泡泡，能夠吸附毛孔髒污清潔乾淨。
              </li>
              <li>含有天然泥土能吸附毛孔髒污清潔乾淨。</li>
              <li>
                添加洗淨輔助成分無患子種子萃取物，保護肌膚同時也洗去髒污。
              </li>
            </ul>
            <p class="font-weight-bold">洗後肌膚保持潤澤</p>
            <ul>
              <li>4種核酸成分讓肌膚充滿潤澤，更具彈性和水潤。</li>
              <li>
                添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na
                等保濕成分。洗後依然維持肌膚潤澤效果。
              </li>
              <li>
                保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。
              </li>
              <li>
                添加甘草酸2K和梔子花萃取物、維生素B12。保護肌膚，有助於肌膚的健康。
              </li>
            </ul>
            <p class="font-weight-bold">讓人心情愉悅的香氣</p>
            <ul>
              <li>
                來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。
              </li>
            </ul>
            <p class="font-weight-bold">對肌膚更溫柔的用心</p>
            <ul>
              <li>不使用酒精、礦物油、色素和香料。</li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">使用方法</h3>
              <p>◆洗顏用：將洗顏皂沾濕，搓揉出泡泡後洗臉，用溫水洗淨。</p>
              <p class="mb-0">
                ◆泡泡面膜用：用起泡網搓揉起泡並將大量的泡泡集中在掌心，然後將泡泡停置臉上約30秒到1分鐘，再用溫水充分洗淨。輕輕按壓泡泡，還可更進一步洗淨毛孔內或皮膚紋路的髒污。
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 7 夢莎逆時雙效洗顏皂Ⅱ end -->
      <!-- 8 夢莎逆時雙效賦活露Ⅱ -->
      <article
        id="product8Detail"
        v-if="$route.params.pid == 8"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活露Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  肌膚充滿水潤感 <br />
                  保濕+導入
                </h2>
                <p>
                  具有能讓肌膚保濕的「保濕機能」和讓美容液成分更容易被肌膚吸收的「導入機能」。快速滲透肌膚內，讓肌膚充滿水潤感。添加時間差保濕成分，即使長時間也能保持水潤。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>120ml</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <p class="font-weight-bold">賦予肌膚水嫩潤澤</p>
            <ul>
              <li>4種核酸成分賦予肌膚水嫩潤澤更潤澤，更有彈性、充滿水感。</li>
              <li>
                添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、玻尿酸Na
                等保濕成分。洗後依然維持肌膚潤澤效果。
              </li>
              <li>
                保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。
              </li>
              <li>
                雛菊花萃取物，歐洲李分解物，維他命C
                誘導體等，使肌膚紋理細緻，更具透明感。
              </li>
              <li>甘草酸2K成分，保護肌膚，有助於肌膚的健康。</li>
            </ul>
            <p class="font-weight-bold">肌膚各處皆能保持水嫩潤澤</p>
            <ul>
              <li>
                根據「高壓分散加工」的特殊技術，由於各個添加成分的分子細微分散、提高浸透力，使肌膚能快速滲透，各處皆保持水嫩潤澤。
              </li>
              <li>
                透過將美容液成分形成超細微膠囊「微乳化技術」的「導入機能」使美容液成分吸收至肌膚。如被吸附般滲透、使肌膚水潤柔軟，維持肌膚容易吸收美容液成分的狀態。
              </li>
            </ul>
            <p class="font-weight-bold">讓水潤感傳達到肌膚的每一個角落</p>
            <ul>
              <li>
                藉由「高壓分散加工」的特殊技術，將添加成分的各個分子細緻的分散，提高滲透度，
                讓肌膚更容易吸收，有助於讓潤澤效果傳達至肌膚每一個角落。
              </li>
              <li>
                將美容液成分化為超微細膠囊的「微分子技術」而生的「導入機能」，將美容液成分導入肌膚，吸收效果更好，更能滲透肌膚，使肌膚更加柔嫩，更能使美容液成分發揮效果。
              </li>
            </ul>
            <p class="font-weight-bold">讓人心情愉悅的香氣</p>
            <ul>
              <li>
                來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。
              </li>
            </ul>
            <p class="font-weight-bold">對肌膚更溫柔的用心</p>
            <ul>
              <li>不使用酒精、礦物油、色素和香料。</li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">使用方法</h3>
              <p class="mb-0">
                取適量在掌心，用兩手手掌包覆全臉，輕輕延展推開，滲透至肌膚。
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 8 夢莎逆時雙效賦活露Ⅱ end -->
      <!-- 9 夢莎逆時雙效賦活霜Ⅱ -->
      <article
        id="product9Detail"
        v-if="$route.params.pid == 9"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活霜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">長時間保持潤澤 <br />保濕+導入</h2>
                <p>
                  添加4種核酸成分。擁有肌膚水潤的「保濕機能」及讓肌膚更容易吸收美容液成分的「導入機能」。透過新乳化技術，讓含有保濕成分和美容液成分的細微粒子更容易滲透至肌膚，感受高度保濕的效果。豐潤的乳霜，滑順的觸感，為肌膚上一層水潤的保護。添加長效保濕因子成分，能長時間保持潤澤。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>30g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">特點</h2>
            <p class="font-weight-bold">更加融合滲透的新粒子</p>
            <ul>
              <li>
                採用剪斷能力高，具有優異均勻分散性，並可以製造出更細微的乳化粒子的新乳化技術。細小的粒子更能將保濕成分與美容液成分滲透至肌膚內。由於微小的粒子更能迅速將保濕成分與美容液成分滲透至肌膚（角質層），提高保濕感，也讓賦活霜更柔潤，更加容易延展，觸感也更佳。
              </li>
              <li>
                將美容液成分以超微細膠囊化的「微分子技術」，透過「導入機能」讓美容液成分更容易被肌膚所吸收，滲透肌膚，使肌膚更加柔軟，維持肌膚狀態。
              </li>
            </ul>
            <p class="font-weight-bold">賦予肌膚水嫩潤澤</p>
            <ul>
              <li>
                參考肌膚角質層內的保濕結構，具有極高保濕性能的乳化型態「液晶構造(lamella
                structure)」，以此開發的「液晶乳化」，能讓賦活霜在肌膚上更加柔潤地延展，水潤溫柔地包覆肌膚。
              </li>
              <li>4種核酸成分賦予肌膚水嫩潤澤，更有彈性、充滿水感。</li>
              <li>
                添加FORDAYS獨家成分「Kasparin」，加上肌膚保護成分翅果鐵刀木葉萃取物、
                玻尿酸Na等保濕成分。洗後依然維持肌膚潤澤效果。
              </li>
              <li>
                添加保濕程度會隨著時間增加的長效保濕因子「生物糖膠-1
                (Biosaccharide Gum-1)」，讓肌膚持續維持水潤。
              </li>
              <li>
                保濕成分Lipidure（聚季銨鹽-51）防止肌膚水分蒸發，保護肌膚。
              </li>
              <li>
                雛菊花萃取物，歐洲李分解物，維他命C
                誘導體等，使肌膚紋理細緻，更具透明感。
              </li>
              <li>甘草酸 2K成分，保護肌膚，也有助於肌膚的健康。</li>
            </ul>
            <p class="font-weight-bold">讓人心情愉悅的香氣</p>
            <ul>
              <li>
                來自精油的清爽柑橘花香調，微微的香氣有助於讓使用者更加放鬆。
              </li>
            </ul>
            <p class="font-weight-bold">對肌膚更溫柔的用心</p>
            <ul>
              <li>不使用酒精、礦物油、色素和香料。</li>
            </ul>
            <div class="product-using-hint">
              <h3 class="mt-0">使用方法</h3>
              <p class="mb-0">
                取用適量在掌心，從臉部中心往外塗抹均勻， <br />
                以微熱手溫包覆並輕輕按壓臉部。
              </p>
            </div>
          </div>
        </section>
      </article>
      <!-- 9 夢莎逆時雙效賦活霜Ⅱ end -->
      <!-- 10 夢莎逆時雙效賦活面膜Ⅱ -->
      <article
        id="product10Detail"
        v-if="$route.params.pid == 10"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/夢莎逆時雙效賦活面膜Ⅱ.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">
                  去除髒汙、擁有光滑透明感<br />按摩+面膜
                </h2>
                <p>
                  <br />添加4種核酸成分洗淨用面膜。
                  <br />使用果酸成分軟化角質層的按摩效果及吸附效果的面膜。
                  <br />有效去除氧化的皮脂、老廢角質、毛孔髒污等。使肌膚光滑呈現透明感。含有水解魚精的膠囊賦予保濕。
                </p>
                <table class="table">
                  <tr>
                    <td class="text-pink">內容量</td>
                    <td>85g</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <h2 class="section-title">特點</h2>
            <p class="font-weight-bold">徹底清除肌膚髒污</p>
            <ul>
              <li>
                添加天然泥與蛋白質分解酵素，能確實去除氧化的皮脂、老廢角質、毛孔髒污等。
              </li>
              <li>
                針對這款商品可以有兩種使用方法。針對肌膚的硬皮、暗沉感到在意的人推薦使用按摩的方式，以及對於毛孔粗大、乾燥肌膚在意的人推薦使用面膜來做保養。
              </li>
              <li>
                徹底洗淨容易因為每日的修護而殘留於肌膚的髒污，接著調整肌膚狀態至化妝水及美容液能快速被肌膚吸收。
              </li>
            </ul>
            <p class="font-weight-bold">肌膚潔淨後仍保有水潤感</p>
            <ul>
              <li>添加4種核酸成分使肌膚保濕滋潤、有彈性及水嫩。</li>
              <li>
                含有水解魚精萃取物的液體膠囊，使用時會在肌膚上蔓延開來使美肌成分滲透至肌膚賦予水潤感。
              </li>
              <li>
                添加富地滋獨家成分「Kasparin」、肌膚保護成分翅果鐵刀木葉萃取物、透明質酸鈉等的保濕成分。清洗後也能保有肌膚的水嫩。
              </li>
              <li>
                添加雛菊萃取物、水解歐洲梨、維他命C衍生物能重整肌膚紋理，實現透明肌。
              </li>
              <li>甘草酸二鉀保護肌膚的同時，使肌膚更加健康。</li>
            </ul>
            <p class="font-weight-bold">愉悅放鬆的香氣</p>
            <ul>
              <li>
                來自精油的清爽柑橘花系香調，微微的香味包覆肌膚，感到放鬆。
              </li>
            </ul>
            <p class="font-weight-bold">質地親膚，使用舒適</p>
            <ul>
              <li>
                不使用酒精(乙醇)、礦物油、色素、香料。使用對肌膚無負擔的配方。
              </li>
            </ul>
          </div>
        </section>
      </article>
      <!-- 10 夢莎逆時雙效賦活面膜Ⅱ end -->
      <!-- 11 新夢莎ED膠原蛋白飲EX -->
      <article
        id="product10Detail"
        v-if="$route.params.pid == 11"
        class="main-section"
      >
        <section class="m-sec">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-md-6 text-center">
                <img
                  src="@/assets/public/images/products/IMG_058-thumb-510x363-1106_2023.png"
                  class="product-detail-main-img w-75"
                />
              </div>
              <div class="col-md-6">
                <h2 class="section-title">內在健康美肌力</h2>
                <p class="pr-3">
                  含有全新升級的鳳梨抽出物、膠原三肽、維生素C、礦物質，並新添加貓爪藤樹皮抽出物等成分均衡搭配，維持健康美麗的每一天。
                </p>
              </div>
            </div>
            <div class="col-md-12">
              <table class="light-table mt-4 mb-4">
                <tr>
                  <th width="35%">產品名稱</th>
                  <td class="font-weight-bold">
                    新夢莎ED膠原蛋白飲EX (清涼飲料水)
                  </td>
                </tr>
                <tr>
                  <th>會員價格(統一售價)</th>
                  <td>NT. 2,250元/盒</td>
                </tr>
                <tr>
                  <th>內容量</th>
                  <td>500毫升 (25毫升×20份)</td>
                </tr>
                <tr>
                  <th>保存方法</th>
                  <td>
                    產品請存放於陰涼處，避免陽光直射、高溫多溼處。開封後請盡早飲用完畢。
                  </td>
                </tr>
                <tr>
                  <th>成分內容物</th>
                  <td>
                    砂糖、蜂蜜、魚膠原蛋白【膠原蛋白(魚皮由來)、明膠(魚皮由來)】、鳳梨抽出物、香料、抗壞血酸(維生素C)、粘稠劑【果膠(檸檬、萊姆)、玉米糖膠】、調味劑(檸檬酸、檸檬酸鈉)、貓爪藤樹皮抽出物(貓爪藤樹皮、麥芽糊精)、普通焦糖色素、鋅酵母、甜味劑(蔗糖素)、硒酵母、鹽酸吡哆辛(維生素B6)、核黃素(維生素B2)、硝酸硫胺明(維生素B1)、鮭魚精巢抽出物、乳化劑(脂肪酸甘油酯)
                  </td>
                </tr>
                <tr>
                  <th>營養標示(每100ml)</th>
                  <td>
                    熱量：54大卡、蛋白質：0.8公克、脂肪：0公克、碳水化合物：12.8公克、糖：10公克、鈉：15.4毫克
                  </td>
                </tr>
                <tr>
                  <th>飲用方式</th>
                  <td>
                    1天限1份。冰鎮並輕搖均勻後飲用。開封後請儘速飲用完畢。
                  </td>
                </tr>
                <tr>
                  <th>過敏原標示</th>
                  <td>●本產品含有魚類及其製品 ●孕婦、授乳婦女及三歲以下嬰幼兒不宜食用 ●使用抗凝血劑者，食用前須先諮詢醫生</td>
                </tr>
              </table>
            </div>
          </div>
        </section>
      </article>
      <!-- 11 新夢莎ED膠原蛋白飲EX end -->
      <div v-if="isMousa">
        <MousaProductSection />
      </div>
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import HeaderNav from "../../components/public/headerNav/productHeaderNav";
import MousaProductSection from "@/components/public/MousaProductSection";
export default {
  name: "ProductDetailScreen",
  components: {
    PublicLayout,
    HeaderNav,
    MousaProductSection,
  },
  computed: {
    showProductTitle() {
      if (this.$route.params.pid in this.productNameList) {
        return this.productNameList[this.$route.params.pid];
      }
      return "";
    },
    isMousa() {
      const id = this.$route.params.pid;
      const name = this.productNameList[id];
      if (name.indexOf("夢莎逆時") >= 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      productNameList: {
        1: "富地滋DN膠原",
        2: "富地滋樂活隨身包",
        3: "新‧夢莎ED膠原蛋白飲",
        4: "LU gia 高機能美容精華液",
        5: "夢莎逆時雙效潔面乳Ⅱ",
        6: "夢莎逆時雙效洗顏霜Ⅱ",
        7: "夢莎逆時雙效洗顏皂Ⅱ",
        8: "夢莎逆時雙效賦活露Ⅱ",
        9: "夢莎逆時雙效潔賦活霜Ⅱ",
        10: "夢莎逆時雙效賦活面膜Ⅱ",
        11: "新夢莎ED膠原蛋白飲EX",
      },
    };
  },
};
</script>
